var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUnitRoom = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4178_2021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60547 4.54547V21.9519H16.2154V3.14172L4.60547 4.54547ZM13.5219 15.5882C12.686 15.5882 12.0358 14.9332 12.0358 14.0909C12.0358 13.2487 12.686 12.5936 13.5219 12.5936C14.3578 12.5936 15.0079 13.2487 15.0079 14.0909C15.0079 14.8396 14.3578 15.5882 13.5219 15.5882Z",
    fill: "#133155",
    stroke: "#133155",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4014 4.9198H20.0237V21.6711",
    stroke: "#133155",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4178_2021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6471,
    height: 20.5882,
    fill: "white",
    transform: "translate(3.67676 2.20593)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnitRoom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/unitRoom.b216b58c.svg";
export { ForwardRef as ReactComponent };